import React from "react";
import styled from "styled-components";

// components
import ResetPasswordViewLink from "../links/ResetPasswordViewLink";
import BodyText from "core/BodyText";
import CodeRequestViewButton from "../links/CodeRequestViewButton";

// styles
import { convertPxToRem } from "frontend/components/helpers";
import { textSm } from "core/fontStyles";
const LBCExplanationStyled = styled(BodyText)`
    margin-top: ${convertPxToRem(8)};
`;

const NonSocialAuthStyled = styled.div`
    margin-top: ${convertPxToRem(8)};

    ${LBCExplanationStyled} {
        &.lbc-explained {
            ${textSm};
        }
    }
`;

const OrStyled = styled(BodyText)`
    margin-top: ${convertPxToRem(24)};
    margin-bottom: ${convertPxToRem(8)};
`;

// component
export const NonSocialAuth = () => {
    return (
        <NonSocialAuthStyled>
            <ResetPasswordViewLink>Forgot your password?</ResetPasswordViewLink>
            <OrStyled type="p" alignment="center">
                or
            </OrStyled>
            <CodeRequestViewButton>Log In with Code</CodeRequestViewButton>
            <LBCExplanationStyled type="p" className="lbc-explained">
                Noun Project will email you a verification code. Please log in
                with code if you are a Facebook or Google user.
            </LBCExplanationStyled>
        </NonSocialAuthStyled>
    );
};

export default NonSocialAuth;
